import { useState } from "react";
import axios from "axios";
import BASE_URL from "../constants/baseUrls";

const useCityList = (foreign, all, flight, accommodation, bus, hasPlan) => {
    const [cities, setCities] = useState([]);
    const [isCityLoading, setIsCityLoading] = useState(false);

    const getCities = async (searchInput = "") => {
        try {
            setIsCityLoading(true);
            const response = await axios.get(`${BASE_URL}/api/v2/basic/cities/`, {
                params: {
                    all: all,
                    foreign: foreign,
                    flight: flight,
                    accommodation: accommodation,
                    has_plan: hasPlan,
                    search: searchInput,
                    bus
                },
            });
            const cityList = response.data.data.results;
            cityList.sort((a, b) => b.usage_flight - a.usage_flight);
            setCities(cityList);
            return cityList;
        } catch (error) {
            console.error("Error fetching city list:", error);
        } finally {
            setIsCityLoading(false);
        }
    };

    return { cities, isCityLoading, getCities };
};

export default useCityList;
